import React from "react";
import { Route, Routes } from "react-router-dom";
import { SplashPage } from "components/pages/SplashPage";
import AuthenticatedApp from "../AuthenticatedApp";
import DelegateLandingPage from "../pages/DelegateLandingPage";
import { UIDErrorPage } from "components/pages/UIDErrorPage";
import { UIDSlateErrorPage } from "components/pages/UIDSlateErrorPage";
import { useAuthentication } from "components/hooks/useAuthentication";

export function AppRoutes() {
  const { isLoggedIn } = useAuthentication();

  return (
    <Routes>
      <Route path="delegate_landing" element={<DelegateLandingPage />} />
      <Route path="uid_error" element={<UIDErrorPage />} />
      <Route path="uid_slate_error" element={<UIDSlateErrorPage />} />

      <Route
        path="*"
        element={isLoggedIn ? <AuthenticatedApp /> : <SplashPage />}
      />
    </Routes>
  );
}
